import noProfilePicIcon from 'assets/icons/contact_noimage.svg';
import React, { useState } from 'react';
import { ZoomImageModal } from '../../../../../../common/modals/ZoomImageModal/ZoomImageModal';

import './ImageMessage.pcss';

type Props = {
  url: string;
  messageDate?: string;
  personName?: string;
  avatar?: string;
  onImageLoadError?: () => void;
};

export const ImageMessage = (props: Props) => {
  const { url, personName, messageDate, avatar, onImageLoadError } = props;
  const [imageLoadError, setImageLoadError] = useState(false);
  const [isZoom, setIsZoom] = useState(false);
  const fileName = url.substring(url.lastIndexOf('/') + 1);

  const onPressImage = () => {
    setIsZoom(true);
  };
  const closeModal = () => {
    setIsZoom(false);
  };

  return imageLoadError ? null : (
    <>
      {isZoom && (
        <ZoomImageModal
          displayImageSrc={url}
          avatarImageSrc={avatar ?? noProfilePicIcon}
          personName={personName ?? ''}
          fileName={fileName}
          date={messageDate}
          closeModal={closeModal}
        />
      )}
      <div className="image-message" onClick={onPressImage}>
        <div className="image-message-container">
          <img
            className="image-message__item"
            src={url}
            onError={() => {
              setImageLoadError(true);
              onImageLoadError?.();
            }}
          />
        </div>
      </div>
    </>
  );
};
